import React from 'react'
import { VENUE_BENEFITS } from '../data/venues'
import { VENUE_PHOTO_GATHERING, VENUE_PHOTO_CHICAGO } from '../data/heroCollage'
import { useScrollReveal } from '../hooks/useScrollReveal'

const CHECK_ICON = 'M20 6 9 17l-5-5'

const ForVenuesSection: React.FC = () => {
  const { ref, visible } = useScrollReveal<HTMLDivElement>()

  return (
    <section id="for-venues" className="v2-section v2-section--light">
      <div ref={ref} className={`v2-container v2-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="v2-section-title v2-section-title--center v2-section-title--dark">
          For <em className="v2-em-green-dark">Venues</em>
        </h2>

        <div className="v2-venues-row">
          <figure className="v2-venue-photo">
            <img alt="People socializing at an Ivy gathering" loading="lazy" src={VENUE_PHOTO_GATHERING} />
          </figure>
          <div>
            <h3>What can Ivy do for me?</h3>
            <p>Ivy brings more people in, and gives them a reason to stay.</p>
            <p>Give people a way to meet while they’re already at your venue, whether they’ve stopped in for coffee or come out with friends.</p>
            <p>You don’t need to train your staff, install new tech, or change anything. We handle everything, from promotion to onboarding and support.</p>
            <a href="mailto:support@ivyapp.com?subject=Venue%20partnership" className="v2-btn v2-btn--primary v2-btn--md">
              Partner with Ivy
            </a>
          </div>
        </div>

        <div className="v2-venues-row v2-venues-row--reverse">
          <div>
            <h3>What do I get?</h3>
            <ul className="v2-checklist v2-checklist--dark">
              {VENUE_BENEFITS.map(benefit => (
                <li key={benefit}>
                  <svg aria-hidden="true" viewBox="0 0 24 24" width={24} height={24} fill="none" stroke="#3F8A60" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
                    <path d={CHECK_ICON} />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
          <figure className="v2-venue-photo">
            <img alt="An Ivy gathering at a Chicago venue" loading="lazy" src={VENUE_PHOTO_CHICAGO} />
          </figure>
        </div>
      </div>
    </section>
  )
}

export default ForVenuesSection
